import { Component, OnInit, Input } from '@angular/core';
import { DebtorManagement } from '../../../shared/models/debtorManagement.model';
import { PortfolioService } from '../../../shared/_services/portfolio.service';
import { AuthenticationService } from '../../../shared/_services/authentication.service';

@Component({
  selector: 'app-debtor-detail',
  templateUrl: './debtor-detail.component.html',
  styleUrls: ['./debtor-detail.component.css']
})
export class DebtorDetailComponent implements OnInit {

  @Input() portfolio: DebtorManagement;
  editing: boolean = false;
  showMore: boolean = false;

  constructor(private portfolioService: PortfolioService,
    private authService: AuthenticationService) { }

  ngOnInit() {
  }

  editDebtor() {
    this.editing = true;

    let inputs = document.getElementsByClassName('debtor-data');
    for (let i = 0; i < inputs.length; i++) {
      inputs.item(i).removeAttribute('readonly');
    }
  }

  saveDebtor() {
    this.editing = false;

    let inputs = document.getElementsByClassName('debtor-data');
    for (let i = 0; i < inputs.length; i++) {
      inputs.item(i).setAttribute('readonly', '');
    }

    this.portfolio.modificationUser = this.authService.currentUserValue.idUser;
    this.portfolioService.updateDebtor(this.portfolio)
      .subscribe(res => console.log(res),
        error => console.log(error));
  }

}
